import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { heroSequence } from '../data/product';
export function HeroSequence() {
  const reduceMotion = useReducedMotion();
  const [index, setIndex] = useState<number>(0);
  useEffect(() => {
    if (reduceMotion) return;
    const id = window.setInterval(() => {
      setIndex(prev => (prev + 1) % heroSequence.length);
    }, 3200);
    return () => window.clearInterval(id);
  }, [reduceMotion]);
  const frame = heroSequence[index];
  return <figure className="w-full border border-white/10 bg-ink-900" data-id="element-307" data-mp="aihybsxaz7qy">
      <div className="relative aspect-[16/9] w-full overflow-hidden bg-ink-950" data-id="element-308" data-mp="fc40gr5ubt8i">
        <AnimatePresence initial={false} mode="popLayout" data-id="element-309" data-mp="jd5zb6vui39y">
          <motion.img key={index} src={frame.src} alt={frame.alt} initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1]
        }} className="absolute inset-0 h-full w-full object-contain" data-id="element-310" data-mp="jeqyj9t3uae5" />
        </AnimatePresence>
      </div>

      <figcaption className="border-t border-white/10 p-4 sm:p-5" data-id="element-311" data-mp="1t096mc5m63ee">
        <p className="font-display text-xl font-bold uppercase leading-tight text-offwhite sm:text-2xl" data-id="element-312" data-mp="1oxcmui4c818v">
          {frame.caption}
        </p>
        <div className="mt-3 flex gap-1.5" data-id="element-313" data-mp="2gnprwuugoxvu">
          {heroSequence.map((step, i) => <button key={step.caption} type="button" aria-label={step.caption} aria-current={i === index} onClick={() => setIndex(i)} className={`h-1 flex-1 transition-colors duration-150 ease-grit ${i === index ? 'bg-grit-500' : 'bg-white/25 hover:bg-white/45'}`} data-id="element-314" data-mp="2gpk33hfxlbmq" data-mpi={i} />)}
        </div>
      </figcaption>
    </figure>;
}